import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import api from "../../../../services/api/service";
import ActionBar from "../../components/ActionBar";
import Input from "../Input";
import { Content } from "./styles";

function BaseInfo({
  t,
  kind,
  data,
  setData,
  errors,
  resetErrors,
  loading,
  setLoading,
  setAvailDeliveryDays
}) {
  const [genError, setGenError] = useState(false);
  const [nextDisabled, disableNext] = useState(true);

  useEffect(() => {
    disableNext(!data.companyId);
  });

  async function handleNext() {
    setLoading(true);
    setGenError(false);

    const orgDetailsResponse = await api.getOrganizationDetails(data.companyId);

    if (orgDetailsResponse.error) {
      setGenError("messages.invalidOrUnknownOrganization");
      setLoading(false);
      return false;
    }

    if (orgDetailsResponse.deliveryZipCode.length >= 4) {
      let searchResp = await api.getDeliveryDays(
        orgDetailsResponse.deliveryZipCode
      );

      setAvailDeliveryDays(searchResp);
    }

    setData({ ...data, ...orgDetailsResponse });
    resetErrors();
    //bad hack to force the validation of the phone number
    setData({ contactPhone: orgDetailsResponse.contactPhone });
    setLoading(false);

    return true;
  }

  function handleChange({ target: { name, value } }) {
    if (!/^[0-9]*$/.test(value)) {
      setGenError("validationMessages.onlyNumbersAllowed");
    } else {
      setData({
        [name]: value
      });
      setGenError(false);
    }
  }

  return (
    <div>
      <Content style={{ padding: "0 15%" }}>
        {genError ? <p className="text-danger">{t(genError)}</p> : null}

        <Input
          id="companyId"
          type="text"
          value={data.companyId}
          error={errors.companyId}
          onChange={handleChange}
          disabled={loading}
        />
      </Content>

      <ActionBar onNext={handleNext} nextDisabled={nextDisabled} />
    </div>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  errors: state.signup.errors,
  loading: state.signup.loading
});

const mapDispatchToProps = dispatch => ({
  setData: data => dispatch({ type: "SET_DATA", payload: data }),
  resetErrors: () => dispatch({ type: "RESET_ERRORS" }),
  setLoading: loading => dispatch({ type: "SET_LOADING", payload: loading }),
  setAvailDeliveryDays: availDays =>
    dispatch({ type: "SET_AVAIL_DELIVERY_DAYS", payload: availDays })
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(BaseInfo)
);
